<template>
  <div>
    <div v-if="userById && Object.keys(userById).length === 0">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <h2>Dane seniora</h2>

      <div class="" style="padding: 0px !important">
        <table
          class="table borderless"
          v-if="userById.user_profile && userById.user_profile.profile"
        >
          <thead>
            <tr class="tr-table">
              <th scope="col">ID</th>
              <th scope="col">Data utworzenia</th>
              <th scope="col">Imie</th>
              <th scope="col">Nazwisko</th>
              <th scope="col">Telefon</th>
              <th scope="col">Bio</th>
              <th scope="col">Ulica</th>
              <th scope="col">Nr domu</th>
              <th scope="col">Nr lokalu</th>
              <th scope="col">Piętro</th>
              <th scope="col">Kod pocztowy</th>
              <th scope="col">Miasto</th>
              <th scope="col">Latitude</th>
              <th scope="col">Longitude</th>
              <th scope="col">Data urodzenia</th>
              <th scope="col">Email</th>
              <th scope="col">Czy email zweryfikowany?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ userById.user_profile.profile.id }}</td>
              <td>{{ userById.user_profile.user.creation_date }}</td>
              <td>{{ userById.user_profile.profile.first_name }}</td>
              <td>{{ userById.user_profile.profile.last_name }}</td>
              <td>{{ userById.user_profile.user.phone }}</td>
              <td style="min-width: 300px">
                {{ userById.user_profile.profile.note }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.street
                    ? userById.user_profile.profile.street
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.number1
                    ? userById.user_profile.profile.number1
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.number2
                    ? userById.user_profile.profile.number2
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.floor
                    ? userById.user_profile.profile.floor
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.postcode
                    ? userById.user_profile.profile.postcode
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.city
                    ? userById.user_profile.profile.city
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.latitude
                    ? userById.user_profile.profile.latitude
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.longitude
                    ? userById.user_profile.profile.longitude
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  formattedDateWithoutTime(
                    userById.user_profile.profile.birthdate
                  )
                }}
              </td>
              <td>{{ userById.user_profile.profile.email }}</td>
              <td>
                {{
                  userById.user_profile.profile.is_email_verified
                    ? "TAK"
                    : "NIE"
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Dane do faktury -->
      <InvoiceDataSection
        v-if="userById && userById.user_profile"
        :profile="userById.user_profile.profile"
        :userId="userById.user_profile.user.id"
        fieldPrefix="customer_"
        @updated="getUserData"
      />

      <div
        v-if="
          userById.user_profile.profile.languages &&
          userById.user_profile.profile.languages.length > 0
        "
      >
        <h2>Więcej o użytkowniku</h2>
        <table
          class="table borderless"
          v-if="
            userById.user_profile &&
            userById.user_profile.profile &&
            userById.user_profile.profile.features &&
            userById.user_profile.profile.features.length > 0
          "
        >
          <thead>
            <tr class="tr-table">
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="feature in userById.user_profile.profile.features"
              :key="feature"
            >
              <td>
                {{ feature.detail }}
                <span
                  v-if="
                    isHealthFeature(feature) &&
                    !userById.user_profile.profile.health_data_consent
                  "
                  class="text-muted"
                  >(niewidoczne dla innych)</span
                >
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="userById.user_profile && userById.user_profile.profile">
          Zgoda na dane o zdrowiu:
          <strong>{{
            healthConsentLabel(userById.user_profile.profile)
          }}</strong>
        </p>
      </div>

      <div
        class="modal fade"
        id="orderFormModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="address"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="address">Zamówienie</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="addOrder">
                <input
                  type="radio"
                  id="one"
                  :value="true"
                  v-model="for_myself"
                  @change="handleForMyself"
                />
                <label for="one">Dla siebie</label>
                <br />
                <input
                  type="radio"
                  id="two"
                  :value="false"
                  v-model="for_myself"
                  @change="handleForMyself"
                />
                <label for="two">Dla kogoś</label>
                <br />
                <br />
                <label for="">Imie</label>
                <input type="text" class="form-control" v-model="firstName" />
                <label for="">Nazwisko</label>
                <input type="text" class="form-control" v-model="lastName" />
                <label for="">Ulica</label>
                <input type="text" class="form-control" v-model="street" />
                <label for="">Nr budynku</label>
                <input type="text" class="form-control" v-model="number1" />
                <label for="">Numer mieszkania</label>
                <input type="text" class="form-control" v-model="number2" />
                <label for="">Piętro</label>
                <input type="text" class="form-control" v-model="floor" />
                <label for="">Kod pocztowy</label>
                <input type="text" class="form-control" v-model="postcode" />
                <label for="">Miasto</label>
                <input type="text" class="form-control" v-model="city" />
                <label for="">Telefon</label>
                <input type="text" class="form-control" v-model="phone" />
                <label for="">Data urodzenia</label>
                <input type="text" class="form-control" v-model="birthdate" />
                <label for="">Email</label>
                <input type="text" class="form-control" v-model="email" />
                <label for="">Kod promocyjny użytkownika</label>
                <br />
                <select v-model="selectedPromotionalCode">
                  <option selected value="">Brak</option>
                  <option
                    v-for="code in userPromotionalCodes.promotionalCodes"
                    :key="code.promotional_code.id"
                    :value="code.id"
                  >
                    {{ code.promotional_code.code }} -
                    {{
                      code.promotional_code.type === "ORDER_DISCOUNT"
                        ? `Zniżka ${code.promotional_code.value * 100}%`
                        : `Zniżka ${code.promotional_code.value}zł`
                    }}
                  </option>
                </select>

                <br />
                <label class="mt-4" for="orderStatus">Status zamówienia</label>
                <br />
                <select
                  class="mb-4"
                  name="orderStatus"
                  v-model="selectedInitialOrderStatus"
                >
                  <option
                    v-for="initialOrderStatus in availableInitialOrderStatuses"
                    :key="initialOrderStatus"
                    :value="initialOrderStatus"
                  >
                    {{ initialOrderStatus }}
                  </option>
                </select>

                <label for="customerNote">Dodatkowe informacje</label>
                <textarea
                  id="customerNote"
                  class="form-control mb-3"
                  v-model="customerNote"
                  rows="3"
                  maxlength="1024"
                  placeholder="Wpisz dodatkowe informacje dla opiekuna (opcjonalnie)"
                ></textarea>

                <button
                  type="submit"
                  class="form-control btn btn-outline-dark"
                  :disabled="inProgress"
                >
                  Dodaj zamówienie
                </button>
              </form>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
                id="orderFormModalCloseButton"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>
      <input class="lat m-0 p-0" name="lat" value="" />
      <input class="lng m-0 p-0" name="lng" value="" />
      <input
        required
        type="text"
        v-model="radius"
        class="form-control radiusInput mapInput m-0 p-0"
        style="visibility: hidden"
        placeholder="Promień"
      />
      <button
        type="button"
        class="btn btn-outline-dark btn-sm"
        style="display: block; margin: 0 auto 20px"
        data-toggle="collapse"
        href="#orderForm"
        role="button"
        aria-expanded="false"
        aria-controls="orderForm"
        :disabled="!hasInvoiceData"
      >
        Zamów usługę dla seniora
      </button>
      <p v-if="!hasInvoiceData" class="no-invoice-data-info">
        Nie można zamówić usługi dla seniora bez dodanych danych do faktury
      </p>
      <div v-if="hasInvoiceData" class="collapse" id="orderForm" style="padding: 0">
        <div class="card card-body">
          <div
            class="googleMap"
            style="width: 100%; height: 300px; margin: 0; padding: 0"
          ></div>
          <form @submit.prevent="searchEmployees">
            <input
              type="text"
              id="my-input-searchbox"
              class="form-control cityInput mapInput"
              placeholder="Adres"
              required
              @change="searchEmployees"
            />
            <div class="calendar">
              <v-calendar
                :attributes="attributes"
                @dayclick="onDayClick"
                :columns="2"
                :min-date="minOrderDate"
                :max-date="new Date(new Date().getTime() + 31556952000)"
                class="p-3"
              ></v-calendar>
              <p style="margin-top: 1rem"><b>Wybrane dni:</b></p>
              <div class="days">
                <span v-for="day in days" :key="day.id">
                  <span style="margin: 10px">{{ day.id }}</span>
                </span>
              </div>
            </div>

            <div class="buttonsToSearch" v-if="days && days.length > 0">
              <select
                name="filtering"
                class="form-control categorySelect mapInput"
                v-model="serviceId"
                required
                @change="searchEmployees"
              >
                <option value="" selected disabled>Usługa</option>
                <option
                  v-for="option in this.allServices"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.serviceCategoryEntity.display_name }} -
                  {{
                    option.sub_category && option.sub_category.display_name
                      ? `${option.sub_category.display_name} - `
                      : ""
                  }}
                  {{
                    !option.description || option.description.length > 100
                      ? option.display_name + " - " + option.name
                      : option.description
                  }}
                  <span v-if="option.is_hidden">(ukryta w aplikacji)</span>
                </option>
              </select>
              <!-- <button
                type="submit"
                class="btn btn-outline-dark mr-3 searchButton mapInput"
              >
                Szukaj dostępnych opiekunów
              </button> -->
            </div>
          </form>

          <div
            class="avaiableEmployees"
            v-if="
              this.serviceId &&
              foundUsers &&
              foundUsers.user_profile_service &&
              foundUsers.user_profile_service.length > 0 &&
              !this.searching
            "
          >
            >
            <h2>Znalezieni opiekunowie</h2>
            <div class="content">
              <div class="icons">
                <img
                  src="../icons/arrowLeft.svg"
                  @click="previousPage()"
                  class="leftArrow"
                  v-if="this.pageNumber > 1"
                />
                <img
                  src="../icons/arrowLeftDisabled.svg"
                  v-else
                  class="disabled-icon leftArrow"
                />

                <img
                  src="../icons/arrowRight.svg"
                  @click="nextPage()"
                  class="rightArrow"
                  v-if="calcPage()"
                />
                <img
                  src="../icons/arrowRightDisabled.svg"
                  v-else
                  class="disabled-icon rightArrow"
                />
              </div>
            </div>
            <table class="table borderless table-responsive">
              <thead>
                <tr class="tr-table w-auto">
                  <th scope="col">Zamów</th>
                  <th scope="col">ID użytkownika</th>
                  <th scope="col">Utworzono</th>
                  <th scope="col">Imię</th>
                  <th scope="col">Nazwisko</th>
                  <th scope="col">Telefon</th>
                  <th scope="col">Data urodzenia</th>
                  <th scope="col">Pesel</th>
                  <th scope="col">Adresy użytkownika</th>
                  <th scope="col">Numer konta</th>
                  <th scope="col">Weryfikacja numeru konta</th>
                  <th scope="col">Status</th>
                  <th scope="col">Dystans</th>
                  <th scope="col">Zdjęcie</th>
                  <th scope="col">Status pracownika</th>
                  <th scope="col">Usługi</th>
                  <th scope="col">Płatności</th>
                  <th scope="col">Wiadomość</th>
                  <th scope="col">Szczegóły</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="data in foundUsers.user_profile_service"
                  :key="data.user_profile.user.id"
                >
                  <td>
                    <div
                      @click="setDataToOrder(userById, service.id)"
                      data-toggle="modal"
                      data-target="#orderFormModal"
                      v-for="service in data.user_services.filter(
                        (s) => s.service.id === serviceId
                      )"
                      :key="service.service.id"
                    >
                      {{ service.price }}zł
                      <button class="btn btn-sm btn-outline-dark">Zamów</button>
                    </div>
                  </td>
                  <td>{{ data.user_profile.user.id }}</td>
                  <td>{{ data.user_profile.user.creation_date }}</td>

                  <td>{{ data.user_profile.profile.first_name }}</td>
                  <td>{{ data.user_profile.profile.last_name }}</td>
                  <td>{{ data.user_profile.user.phone }}</td>
                  <td>
                    {{
                      data.user_profile.profile.birthdate
                        ? formattedDateWithoutTime(
                            data.user_profile.profile.birthdate
                          )
                        : ""
                    }}
                  </td>
                  <td>{{ data.user_profile.profile.pesel }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-toggle="modal"
                      :data-target="`#address${data.user_profile.user.id}`"
                    >
                      Pokaż
                    </button>
                  </td>
                  <td>{{ data.user_profile.profile.account_number }}</td>
                  <td
                    v-if="
                      !data.user_profile.profile.payment_verification_status ||
                      data.user_profile.profile.payment_verification_status ===
                        'NOT_INITIALIZED'
                    "
                  >
                    Nie rozpoczęto płatności weryfikacyjnej
                  </td>
                  <td
                    v-if="
                      data.user_profile.profile.payment_verification_status ===
                      'ACCEPTED'
                    "
                  >
                    Płatność weryfikacyjna zakończona pomyślnie
                  </td>
                  <td
                    v-if="
                      data.user_profile.profile.payment_verification_status ===
                      'CREATED'
                    "
                  >
                    Płatność weryfikacyjna rozpoczęta, lecz niedokończona
                  </td>
                  <td
                    v-if="
                      data.user_profile.profile.payment_verification_status ===
                      'REJECTED'
                    "
                  >
                    Płatność weryfikacyjna zakończona niepowodzeniem
                  </td>

                  <td>{{ data.user_profile.profile.profile_status }}</td>
                  <td>{{ data.user_profile.profile.distance }}</td>
                  <td>
                    <a
                      target="_blank"
                      :href="
                        getUrl() +
                        '/api/profile/photo/' +
                        data.user_profile.profile.file_path
                      "
                    >
                      <img
                        class="img-avatar"
                        :src="
                          getUrl() +
                          '/api/profile/photo/' +
                          data.user_profile.profile.file_path
                        "
                      />
                    </a>
                  </td>

                  <!-- :src="requestPhoto(data.user_profile.profile.fileId)" -->
                  <td>{{ data.user_profile.profile.employee_status }}</td>

                  <td>
                    <button
                      v-if="data.user_services && data.user_services.length > 0"
                      type="button"
                      class="btn btn-outline-dark"
                      data-toggle="modal"
                      :data-target="`#userServices${data.user_profile.user.id}`"
                      v-on:click="setCurrentUserServices(data.user_services)"
                    >
                      Usługi
                    </button>
                    <span v-else>Brak usług</span>
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: 'PaymentsList',
                        query: { search: data.user_profile.user.phone },
                      }"
                    >
                      <button type="button" class="btn btn-outline-dark mr-3">
                        Płatności
                      </button>
                    </router-link>
                  </td>

                  <td>
                    <router-link
                      :to="{ path: 'chat/' + data.user_profile.user.id }"
                    >
                      <button type="button" class="btn btn-outline-dark mr-3">
                        Napisz
                      </button>
                    </router-link>
                  </td>
                  <td>
                    <router-link
                      :to="{ path: 'users/id/' + data.user_profile.user.id }"
                    >
                      <button
                        type="button"
                        class="btn btn-outline-dark mr-3"
                        @click="getUser(data.user_profile.user.id)"
                      >
                        Przejdź
                      </button>
                    </router-link>
                  </td>

                  <div
                    class="modal fade"
                    :id="`userServices${data.user_profile.user.id}`"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-xl modal-xl" role="dialog">
                      <div class="modal-content services-modal">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel">
                            Usługi użytkownika
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <table class="table modal-table">
                            <thead>
                              <tr class="tr-table">
                                <th scope="col">ID</th>
                                <th scope="col">Cena</th>
                                <th scope="col">ID usługi</th>
                                <th scope="col">Nazwa</th>
                                <th scope="col">Opis</th>
                                <th scope="col">Pierwszy próg</th>
                                <th scope="col">Drugi próg</th>
                                <th scope="col">Typ</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="item in currentUserServices"
                                v-bind:key="item.id"
                              >
                                <td>{{ item.id }}</td>
                                <td>{{ item.price }}</td>
                                <td>{{ item.service.id }}</td>
                                <td>{{ item.service.display_name }}</td>
                                <td>{{ item.service.description }}</td>
                                <td>{{ item.service.first_threshold }}</td>
                                <td>{{ item.service.second_threshold }}</td>
                                <td>{{ item.service.type }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-dark"
                            data-dismiss="modal"
                          >
                            Zamknij
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Adresy użytkownika -->
                  <div
                    class="modal fade"
                    :id="`address${data.user_profile.user.id}`"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="address"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-xl" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="address">
                            Adresy użytkownika
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="changes = null"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <h4>Adres do faktury</h4>
                          <table class="table modal-table">
                            <thead>
                              <tr class="tr-table">
                                <th scope="col">Kod pocztowy</th>
                                <th scope="col">Miasto</th>
                                <th scope="col">Ulica</th>
                                <th scope="col">Numer budynku</th>
                                <th scope="col">Numer mieszkania</th>
                                <th scope="col">Piętro</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>
                                  {{
                                    data.user_profile.profile.postcode_invoice
                                      ? data.user_profile.profile
                                          .postcode_invoice
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.city_invoice
                                      ? data.user_profile.profile.city_invoice
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.street_invoice
                                      ? data.user_profile.profile.street_invoice
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.number1_invoice
                                      ? data.user_profile.profile
                                          .number1_invoice
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.number2_invoice
                                      ? data.user_profile.profile
                                          .number2_invoice
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.floor_invoice
                                      ? data.user_profile.profile.floor_invoice
                                      : "Brak"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <h4>Adres świadczenia usług</h4>
                          <table class="table modal-table">
                            <thead>
                              <tr class="tr-table">
                                <th scope="col">Kod pocztowy</th>
                                <th scope="col">Miasto</th>
                                <th scope="col">Ulica</th>
                                <th scope="col">Numer budynku</th>
                                <th scope="col">Numer mieszkania</th>
                                <th scope="col">Piętro</th>
                                <th scope="col">Latitude</th>
                                <th scope="col">Longitude</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>
                                  {{
                                    data.user_profile.profile.employee_postcode
                                      ? data.user_profile.profile
                                          .employee_postcode
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.employee_city
                                      ? data.user_profile.profile.employee_city
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.employee_street
                                      ? data.user_profile.profile
                                          .employee_street
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.employee_number1
                                      ? data.user_profile.profile
                                          .employee_number1
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.employee_number2
                                      ? data.user_profile.profile
                                          .employee_number2
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.employee_floor
                                      ? data.user_profile.profile.employee_floor
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.employee_latitude
                                      ? data.user_profile.profile
                                          .employee_latitude
                                      : "Brak"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.user_profile.profile.employee_longitude
                                      ? data.user_profile.profile
                                          .employee_longitude
                                      : "Brak"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-dark"
                            data-dismiss="modal"
                            @click="changes = null"
                          >
                            Zamknij
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="
              this.foundUsers &&
              this.foundUsers.user_profile_service &&
              this.foundUsers.user_profile_service.length == 0 &&
              this.serviceId &&
              !this.searching &&
              this.days &&
              this.days.length > 0
            "
          >
            <h4 style="text-align: center">Nie znaleziono żadnego opiekuna</h4>
          </div>
          <div
            v-if="searching"
            class="spinner-border text-secondary"
            role="status"
            style="margin: auto; margin-top: 50px; margin-bottom: 50px"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../axios";
import shared from "../shared";
import { URL } from "../axios";
import gmapsInit from "../gmaps";
import VCalendar from "v-calendar/lib/components/calendar.umd";
import moment from "moment";
import InvoiceDataSection from "../components/InvoiceDataSection.vue";
export default {
  name: "SeniorProfile",
  components: {
    VCalendar,
    InvoiceDataSection,
  },
  data: function () {
    return {
      daysChanged: false,
      pageNumber: 1,
      onPage: 30,
      radius: 30,
      emloyees: [],
      searching: false,
      firstName: "",
      lastName: "",
      street: "",
      number1: "",
      number2: "",
      floor: "",
      postcode: "",
      city: "",
      phone: "",
      birthdate: "",
      email: "",
      customerNote: "",
      time: "NONE",
      for_myself: true,
      selectedService: "",
      categoryServices: [],
      selectedDescription: "",
      inProgress: false,
      foundEmployee: false,
      selectedLat: "",
      selectedLng: "",
      currentUserServices: [],
      days: [],
      dayChangedTimer: null,
      pageNumberChanged: false,
      selectedPromotionalCode: "",
      userPromotionalCodes: [],
      serviceId: "",
      selectedInitialOrderStatus: "WAITING",
    };
  },
  computed: {
    availableInitialOrderStatuses() {
      //if all selected day in 'days' are from the past, then only 'FINISHED' status is available
      if (
        this.days.length > 0 &&
        this.days.every((day) =>
          moment(day.date).startOf("day").isBefore(moment().startOf("day"))
        )
      ) {
        return ["FINISHED"];
      }

      //if one of the selected days is in the future, then 'ACCEPTED'
      if (this.days.length > 0) {
        return ["WAITING", "ACCEPTED"];
      }
      return ["WAITING", "ACCEPTED", "FINISHED"];
    },
    minOrderDate() {
      return moment().subtract(2, "weeks").toDate();
    },
    allServices() {
      return this.$store.getters.getAllServices;
    },
    dates() {
      return this.days.map((day) => day.date);
    },
    attributes() {
      return this.dates.map((date) => ({
        highlight: {
          color: moment(date).startOf("day").isBefore(moment().startOf("day"))
            ? "red"
            : "blue",
          fillMode: "solid",
        },
        dates: date,
      }));
    },
    userById() {
      return this.$store.getters.getUserById;
    },
    hasInvoiceData() {
      const profile = this.userById?.user_profile?.profile;
      return !!(
        profile &&
        (profile.customer_postcode_invoice ||
          profile.customer_company_name ||
          profile.customer_first_name_invoice)
      );
    },
    ratings() {
      return this.$store.getters.getAddedRatings;
    },
    foundUsers() {
      return this.$store.getters.getUserInSpecifiedArea;
    },
  },

  async created() {
    this.formattedDate = shared.formattedDate;
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    await this.$store.dispatch("getAllServices");
    this.getUserData();
    this.$store.dispatch("fetchAddedRatings", {
      user_id: this.$route.params.id,
    });

    axios
      .get(
        `/api/userPromotionalCode?promotional=true&active=true&userId=${this.$route.params.id}`
      )
      .then((response) => {
        this.userPromotionalCodes = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  watch: {
    availableInitialOrderStatuses() {
      this.selectedInitialOrderStatus = this.availableInitialOrderStatuses[0];
    },
    userById() {
      this.loadMap();
    },
    categoryServices() {
      if (this.categoryServices && this.categoryServices.length > 0) {
        this.selectedDescription = this.categoryServices[0].id;
      }
    },
    selectedDescription() {
      this.foundEmployee = false;
    },
    selectedLat() {
      this.resetPage();
      this.searchEmployees();
    },
    serviceId() {
      this.resetPage();
    },
    searching() {
      if (!this.pageNumberChanged && this.searching) {
        this.resetPage();
      }
    },
  },
  methods: {
    isHealthFeature(feature) {
      return shared.isHealthFeature(
        this.userById.user_profile.profile,
        feature
      );
    },
    healthConsentLabel(profile) {
      return shared.healthConsentLabel(profile);
    },
    async loadMap() {
      const google = await gmapsInit();
      const geocoder = new google.maps.Geocoder();
      const mapSelector = this.$el.querySelector(".googleMap");
      if (mapSelector) {
        let map = new google.maps.Map(mapSelector);
        map.setMapTypeId("roadmap");
        geocoder.geocode({ address: `90-413 Łódź` }, (results, status) => {
          if (status !== "OK" || !results[0]) {
            throw new Error(status);
          }
          map.setCenter(results[0].geometry.location);
          map.fitBounds(results[0].geometry.viewport);

          const input = document.getElementById("my-input-searchbox");
          const searchBox = new google.maps.places.SearchBox(input);
          map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(input);
          map.addListener("bounds_changed", function () {
            searchBox.setBounds(map.getBounds());
          });
          let markers = [];
          let circles = [];
          searchBox.addListener("places_changed", function () {
            const places = searchBox.getPlaces();
            if (!places || places.length == 0) {
              return;
            }

            markers.forEach(function (marker) {
              marker.setMap(null);
            });
            circles.forEach((circle) => {
              circle.setMap(null);
            });
            markers = [];
            circles = [];
            const bounds = new google.maps.LatLngBounds();
            let lat;
            let lng;
            places.forEach(function (place) {
              if (!place.geometry) {
                return;
              }
              markers.push(
                new google.maps.Marker({
                  map: map,
                  position: place.geometry.location,
                  draggable: true,
                })
              );
              const radius =
                document.querySelector(".radiusInput").value * 1000;
              markers.forEach((marker) => {
                lat = marker.getPosition().lat();
                lng = marker.getPosition().lng();

                const circle = new google.maps.Circle({
                  map: map,
                  radius: parseInt(radius), // 10 miles in metres
                  fillColor: "grey",
                });
                circle.bindTo("center", marker, "position");
                circles.push(circle);
                marker.addListener("dragend", (marker) => {
                  const lat = marker.latLng.lat();
                  const lng = marker.latLng.lng();

                  document.querySelector('input[name="lat"]').value = lat;
                  document.querySelector('input[name="lng"]').value = lng;
                  document.querySelector(".lat").innerHTML = lat;
                  document.querySelector(".lng").innerHTML = lng;
                });
              });
              if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport);
              } else {
                bounds.extend(place.geometry.location);
              }
            });
            const coordinates = {
              lat: lat,
              lng: lng,
            };
            map.fitBounds(bounds);
            document.querySelector(".lat").innerHTML = coordinates.lat;
            document.querySelector(".lng").innerHTML = coordinates.lng;
            document.querySelector('input[name="lat"]').value = coordinates.lat;
            document.querySelector('input[name="lng"]').value = coordinates.lng;
            return coordinates;
          });
        });
      }
    },

    resetPage() {
      this.pageNumber = 1;
    },
    onDayClick(day) {
      this.resetPage();
      try {
        if (this.dayChangedTimer) {
          clearTimeout(this.dayChangedTimer);
        }
      } catch (error) {
        this.dayChangedTimer = null;
      }
      if (
        moment(day.id).isAfter(moment(this.minOrderDate).add(-1, "day"), "day")
      ) {
        this.daysChanged = true;
        const idx = this.days.findIndex((d) => d.id === day.id);
        if (idx >= 0) {
          this.days.splice(idx, 1);
        } else {
          this.days.push({
            id: day.id,
            date: day.date,
          });
        }
        this.dayChangedTimer = setTimeout(() => {
          this.searchEmployees();
        }, 2000);
      }
    },
    calcPage() {
      const page_number = this.pageNumber;
      const total_value = this.foundUsers.total_value;
      const on_page = this.onPage;

      if (total_value / on_page > page_number) {
        return true;
      } else {
        return false;
      }
    },
    async nextPage() {
      this.pageNumberChanged = true;
      this.pageNumber = this.pageNumber + 1;
      await this.searchEmployees(this.onPage, this.pageNumber);
      this.pageNumberChanged = false;
    },
    async previousPage() {
      if (this.pageNumber > 0) {
        this.pageNumberChanged = true;
        this.pageNumber = this.pageNumber - 1;
        await this.searchEmployees(this.onPage, this.pageNumber - 1);
        this.pageNumberChanged = false;
      }
    },

    setCurrentUserServices(services) {
      this.currentUserServices = services;
    },
    handleForMyself() {
      if (this.for_myself) {
        const user = this.userById.user_profile;
        this.firstName = user.profile.first_name;
        this.lastName = user.profile.last_name;
        this.street = user.profile.street;
        this.number1 = user.profile.number1;
        this.number2 = user.profile.number2;
        this.floor = user.profile.floor;
        this.postcode = user.profile.postcode;
        this.city = user.profile.city;
        this.phone = user.user.phone;
        this.birthdate = user.profile.birthdate;
        this.email = user.profile.email;
      }
      if (!this.for_myself) {
        this.getClosePersonData();
      }
    },
    getClosePersonData() {
      axios
        .get(`api/close-person?userId=${this.userById.user_profile.user.id}`)
        .then((response) => {
          const user = response.data;
          this.firstName = user.first_name;
          this.lastName = user.last_name;
          this.street = user.street;
          this.number1 = user.number1;
          this.number2 = user.number2;
          this.floor = user.floor;
          this.postcode = user.postcode;
          this.city = user.city;
          this.phone = user.phone;
          this.birthdate = user.birthdate;
          this.email = user.email;
        });
    },

    async addOrder() {
      this.inProgress = true;
      const order_days = this.days.map((day) =>
        moment(day.date).format("YYYY-MM-DD 20:00:00.000")
      );
      const inputLatValue = document.querySelector('input[name="lat"]').value;
      const inputLngValue = document.querySelector('input[name="lng"]').value;

      const body = {
        customer_request: {
          first_name: this.firstName,
          last_name: this.lastName,
          street: this.street,
          number1: this.number1,
          number2: this.number2,
          floor: this.floor,
          postcode: this.postcode,
          city: this.city,
          phone: this.phone,
          birthdate: this.birthdate,
          email: this.email,
          note: this.customerNote || "",
        },
        time: this.time,
        for_myself: this.for_myself,
        from_admin: true,
        customer_phone: this.userById.user_profile.user.phone,
        order_days,
        promotion_id: this.selectedPromotionalCode,
        initial_order_status: this.selectedInitialOrderStatus,
      };
      if (inputLatValue) {
        body.customer_request.latitude = inputLatValue;
        body.customer_request.longitude = inputLngValue;
      }

      await axios
        .post(`/api/order/${this.selectedService}`, body)
        .then((response) => {
          if (response && response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano zamówienie",
            });
            this.newTaskMessage = "";
            this.file = null;
            this.customerNote = "";
            document.getElementById("orderFormModalCloseButton").click();
            axios
              .get(
                `/api/userPromotionalCode?promotional=true&active=true&userId=${this.$route.params.id}`
              )
              .then((response) => {
                this.userPromotionalCodes = response.data;
              })
              .catch((error) => {
                console.log(error);
              });
          }
          this.inProgress = false;
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.error === "not_enough_money"
          ) {
            this.$notify({
              group: "error",
              text: "Użytkownik nie posiada wystarczająco pieniędzy w portfelu, aby zamówić usługę",
            });
          } else if (
            err.response &&
            err.response.data &&
            err.response.data.error === "invalid_birthdate"
          ) {
            this.$notify({
              group: "error",
              text: "Data urodzenia musi być w formacie YYYY-MM-DD",
            });
          } else {
            this.$notify({
              group: "error",
              text: "Nie udało się dodać zamówienia",
            });
          }

          this.inProgress = false;
        });
    },
    setDataToOrder(userById, serviceId) {
      const user = userById.user_profile;
      this.firstName = user.profile.first_name;
      this.lastName = user.profile.last_name;
      this.street = user.profile.street;
      this.number1 = user.profile.number1;
      this.number2 = user.profile.number2;
      this.floor = user.profile.floor;
      this.postcode = user.profile.postcode;
      this.city = user.profile.city;
      this.phone = user.user.phone;
      this.birthdate = user.profile.birthdate;
      this.email = user.profile.email;
      this.customerNote = "";
      this.selectedService = serviceId;
      this.selectedPromotionalCode = "";
    },
    async searchEmployees() {
      if (this.days && this.days.length > 0) {
        this.searching = true;
        setTimeout(async () => {
          const lat = document.querySelector('input[name="lat"]').value;
          const lng = document.querySelector('input[name="lng"]').value;
          const radius = document.querySelector(".radiusInput").value;

          if (
            lat &&
            lng &&
            this.serviceId &&
            lat !== "undefined" &&
            lng !== "undefined"
          ) {
            //DEFAULT Łódź
            const coordinates = {
              lat: lat ? lat : "51.7592485",
              lng: lng ? lng : "19.4559833",
            };
            const order_days = this.days.map((day) =>
              moment(day.date).format("YYYY-MM-DD 15:00:00")
            );
            await this.$store.dispatch(
              "fetchUsersInSpecifiedAreaByEmployeeRadius",
              {
                serviceCategoryId: this.serviceId,
                coordinates,
                on_page: this.onPage ? this.onPage : 30,
                page_number: this.pageNumber ? this.pageNumber : 1,
                radius,
                order_days,
              }
            );
            this.searching = false;
          } else if (this.dates.length === 0) {
            this.$notify({
              group: "error",
              text: "Wybierz datę",
            });
            this.searching = false;
          } else if (!this.serviceId) {
            this.$notify({
              group: "error",
              text: "Wybierz usługę",
            });
            this.searching = false;
          } else {
            this.$notify({
              group: "error",
              text: "Wybierz lokalizację",
            });
            this.searching = false;
          }
        }, 500);
      }
    },
    getUrl() {
      return URL;
    },
    getUserData() {
      this.$store.dispatch("getUserById", {
        userId: this.$route.params.id,
      });
    },
  },
};
</script>

<style scoped>
.collapse {
  margin-bottom: 200px;
}
.btn:disabled {
  pointer-events: none;
}
.no-invoice-data-info {
  font-size: 12px;
  color: #dc3545;
  text-align: center;
  margin-top: -10px;
}
.cityInput {
  width: 400px;
  margin: 0 auto;
  margin-bottom: 5px;
  border: 1px solid rgb(80, 78, 78);
}
.mapInput {
  margin-top: 20px;
  width: 400px;
  border: 2px solid rgb(87, 84, 84);
  border-radius: 10px;
  -webkit-box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);
}
.lat,
.lng {
  visibility: hidden;
}
.buttonsToSearch {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
}
.searchButton {
  margin-right: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avaiableEmployees {
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.card {
  background: #f2f2f2;
  margin: 0;
  padding: 0;
}
.icons img {
  height: 30px;
  cursor: pointer;
  border: 1px solid #e5e5e9;
  padding: 5px 20px 5px 20px;
}
.rightArrow {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.leftArrow {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.content {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.pages {
  font-size: 14px;
  font-weight: bold;
}
.calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
}
.days {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20%;
  padding-right: 20%;
  justify-content: center;
}
</style>
